import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { cn } from '../ui';

export function TextShimmer({ children, as: Component = 'p', className, duration = 1, spread = 2 }) {
  const MotionComponent = typeof Component === 'string' ? motion[Component] || motion.span : motion(Component);
  const dynamicSpread = useMemo(() => children.length * spread, [children, spread]);

  return (
    <MotionComponent
      className={cn(
        'relative inline-block bg-[length:250%_100%,auto] bg-clip-text text-transparent',
        '[--base-color:hsl(var(--muted-foreground)/50)] [--base-gradient-color:hsl(var(--foreground))]',
        'dark:[--base-gradient-color:hsl(var(--primary))]',
        '[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))] [background-repeat:no-repeat,padding-box]',
        className
      )}
      initial={{ backgroundPosition: '100% center' }}
      animate={{ backgroundPosition: '0% center' }}
      transition={{ repeat: Infinity, duration, ease: 'linear' }}
      style={{
        '--spread': `${dynamicSpread}px`,
        backgroundImage: 'var(--bg), linear-gradient(var(--base-color), var(--base-color))',
      }}
    >
      {children}
    </MotionComponent>
  );
}
